import * as marietta from '../../..';
import { SVGSprite } from '../../flash/display';

export default class ButtonReverse {
  viewObj: Element;

  callBackFunc: Function;

  x: number;

  y: number;

  rotation: number = 0;

  transformMatrix: string;

  targetItem: marietta.webcad.item.MonicaObject;

  public spt: SVGSprite;

  /**
   * コンストラクタ
   * */
  constructor(container: Element, target: marietta.webcad.item.MonicaObject) {
    this.viewObj = document.querySelector('#lib_icon_reverse svg > g').cloneNode(true) as HTMLElement;
    this.viewObj.setAttribute('id', 'icon_reverse');
    container.appendChild(this.viewObj);

    // アクション
    if (marietta.webcad.WebCADGlobal.userAgentManager.isMobile || marietta.webcad.WebCADGlobal.userAgentManager.isTablet) {
      this.viewObj.addEventListener('touchend', this.onMouseUpMe, { passive: false });
    } else {
      this.viewObj.addEventListener('mouseup', this.onMouseUpMe);
    }

    this.targetItem = target;
  }

  /**
   * マウスダウンされた
   * @param MouseEvent
   */
  onMouseUpMe = (e: MouseEvent) => {
    // 選択モードのときは、バブリングさせない
    e.stopPropagation();

    this.targetItem.reverse();
    marietta.webcad.WebCADGlobal.itemManager.currentItem = this.targetItem;
  };

  /**
   * 移動 XY
   */
  move(x: number, y: number) {
    this.x = x;
    this.y = y;
    this.updateTranslate();
  }

  /**
   * 移動X
   */
  moveX(x: number) {
    this.x = x;
    this.updateTranslate();
  }

  /**
   * 移動Y
   */
  moveY(y: number) {
    this.y = y;
    this.updateTranslate();
  }

  /**
   * Translateのアップデート
   */
  updateTranslate() {
    // レイヤーのスケールの分、割ってやる事で見た目のサイズを維持する
    const root: SVGSprite = marietta.webcad.WebCADGlobal.layerGroup.spt;
    const sc: number = 1.5 / root.scaleX;

    // x,yについては、位置補正で使用している固定値6.5/25に対してのみスケールを適用する
    this.transformMatrix = `matrix(${sc},0,0,${sc},${this.x + 35 - 35 * sc},${this.y})`;

    // this.transformMatrix = "matrix(1,0,0,1," + this.x + "," + this.y + ")";
    this.viewObj.setAttribute('transform', this.transformMatrix);
  }

  /**
   * アイコンの非表示
   */
  hide() {
    (<HTMLElement> this.viewObj).style.visibility = 'hidden';
  }

  /**
   * アイコンの表示
   */
  show() {
    (<HTMLElement> this.viewObj).style.visibility = 'visible';
  }
}
